import type { FormConfig } from '../types';

const formConfig: FormConfig = {
  live: false,
  id: 'rpalogin',
  formName: 'RPA Login',
  title: 'RPA Login',
  subTitle: '',
  showSections: false,
  sections: [
    {
      title: 'RPA Login',
      slug: 'rpa-login',
      subsections: [
        {
          title: 'RPA Login',
          slug: 'rpa-login',
          pages: [
            {
              name: 'rpa-login',
              title: 'RPA Login',
              pageType: 'information',
            },
          ],
        },
      ],
    },
  ],
};

export default formConfig;
